// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Pi3P","signatureBlock":"Footer_signatureBlock__1UMlE","signature":"Footer_signature__25I9M"};